var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"controller-card-skeleton"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"title"}),_vm._l((2),function(key){return [_c('div',{key:key,staticClass:"card-item"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"label"})])]})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-badge"})])
}]

export { render, staticRenderFns }